import React, { useState, useEffect } from 'react';
import { FaQuoteLeft, FaChevronLeft, FaChevronRight, FaStar } from 'react-icons/fa';
import './Depoimentos.css';

const depoimentos = [
  {
    id: 1,
    nome: "Wendell",
    curso: "Tecnologia da Informação",
    texto: "Gostaria de expressar minha profunda gratidão pelo apoio que recebi de vocês ao longo do meu percurso no curso de Tecnologia da Informação pela UNIVESP. Graças à dedicação e comprometimento dessa equipe maravilhosa, estou prestes a concluir minha formação, com a colação de grau prevista para o mês de agosto/2025."
  },
  {
    id: 2,
    nome: "Rebeca",
    curso: "Pedagogia",
    texto: "Vocês são os melhores professores, merecem todo esse reconhecimento. ☺️"
  },
  {
    id: 3,
    nome: "Érika",
    curso: "Tecnologia em Processos Gerenciais",
    texto: "Meu nome é Erika, tenho 54 anos e resolvi voltar a estudar. Juro que achei que não iria conseguir, muito tempo parada, engrenagens do cérebro enferrujadas. Fui apresentada ao EAD por uma amiga. Hoje eu fiz minha última prova do curso de Tecnólogo em Processos Gerenciais. Gostaria de agradecer o EAD por me acompanhar, ajudar, apoiar... Tenho certeza que sem vocês eu não conseguiria."
  },
  {
    id: 4,
    nome: "Marco",
    curso: "Engenharia de Computação",
    texto: "Continuem oferecendo seus serviços de acompanhamento com a excelência que só o EAD Conect tem!"
  },
  {
    id: 5,
    nome: "Lourenço",
    curso: "Negócios e Produção",
    texto: "Sou um cliente de vocês, gosto muito do trabalho que vocês desenvolvem. Parabéns e obrigado pela ajuda."
  },
  {
    id: 6,
    nome: "Marcos",
    curso: "UNIVESP",
    texto: "Gostaria só de agradecer o trabalho de vocês! É fantástico! Que o Eterno abençoe vocês. Sucesso sempre."
  },
  {
    id: 7,
    nome: "Paulo",
    curso: "UNIVESP",
    texto: "Professor Joel, estou vendo seu vídeo comentando as questões de ética. Parabéns Joel pela sua clareza, didática. Para mim o EAD se tornou indispensável. Trabalho incrível que você faz."
  },
  {
    id: 8,
    nome: "Samir",
    curso: "UNIVESP",
    texto: "Vocês são demais. Parabéns por esse conteúdo. Que Deus abençoe vocês."
  },
  {
    id: 9,
    nome: "Sérgio",
    curso: "UNIVESP",
    texto: "Ajudou muito a plataforma EAD. Profissionais diferenciados. Parabéns aos envolvidos."
  }
];

function Depoimentos() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAutoPlay, setIsAutoPlay] = useState(true);

  // Auto-play do carrossel
  useEffect(() => {
    if (!isAutoPlay) return;

    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => 
        prevIndex === depoimentos.length - 1 ? 0 : prevIndex + 1
      );
    }, 5000); // Troca a cada 5 segundos

    return () => clearInterval(interval);
  }, [isAutoPlay]);

  const nextDepoimento = () => {
    setIsAutoPlay(false);
    setCurrentIndex(currentIndex === depoimentos.length - 1 ? 0 : currentIndex + 1);
    setTimeout(() => setIsAutoPlay(true), 10000); // Reativa auto-play após 10s
  };

  const prevDepoimento = () => {
    setIsAutoPlay(false);
    setCurrentIndex(currentIndex === 0 ? depoimentos.length - 1 : currentIndex - 1);
    setTimeout(() => setIsAutoPlay(true), 10000); // Reativa auto-play após 10s
  };

  const goToDepoimento = (index) => {
    setIsAutoPlay(false);
    setCurrentIndex(index);
    setTimeout(() => setIsAutoPlay(true), 10000); // Reativa auto-play após 10s
  };

  const depoimentoAtual = depoimentos[currentIndex];

  return (
    <div className="depoimentos-container">
      <div className="depoimentos-header">
        <h3 className="depoimentos-titulo">O que nossos alunos dizem</h3>
        <div className="depoimentos-rating">
          {[...Array(5)].map((_, i) => (
            <FaStar key={i} className="star-icon" />
          ))}
          <span className="rating-text">4.9/5 - Baseado em {depoimentos.length} avaliações</span>
        </div>
      </div>

      <div className="depoimentos-carousel">
        <button 
          className="carousel-btn prev-btn" 
          onClick={prevDepoimento}
          aria-label="Depoimento anterior"
        >
          <FaChevronLeft />
        </button>

        <div className="depoimento-card">
          <div className="quote-icon">
            <FaQuoteLeft />
          </div>
          
          <div className="depoimento-content">
            <p className="depoimento-texto">
              "{depoimentoAtual.texto}"
            </p>
            
            <div className="depoimento-autor">
              <div className="autor-info">
                <h4 className="autor-nome">{depoimentoAtual.nome}</h4>
                <p className="autor-curso">{depoimentoAtual.curso}</p>
              </div>
            </div>
          </div>
        </div>

        <button 
          className="carousel-btn next-btn" 
          onClick={nextDepoimento}
          aria-label="Próximo depoimento"
        >
          <FaChevronRight />
        </button>
      </div>

      {/* Indicadores */}
      <div className="carousel-indicators">
        {depoimentos.map((_, index) => (
          <button
            key={index}
            className={`indicator ${index === currentIndex ? 'active' : ''}`}
            onClick={() => goToDepoimento(index)}
            aria-label={`Ir para depoimento ${index + 1}`}
          />
        ))}
      </div>

      {/* Indicador de auto-play */}
      <div className="autoplay-indicator">
        <div 
          className={`autoplay-progress ${isAutoPlay ? 'running' : 'paused'}`}
          style={{ animationDuration: '5s' }}
        />
      </div>
    </div>
  );
}

export default Depoimentos;